

export const FULL_SCREEN_TOGGLE = "toggle:full-screen"
